import gql from "graphql-tag";

export const PLAN_INTERVENTION = gql`
  mutation planIntervention(
    $where: InterventionIntervalsWhereInput
    $data: InputIntervalData
  ) {
    planIntervention(where: $where, data: $data) {
      data {
        date
        intervals {
          start
          end
        }
      }
    }
  }
`;

export const CREATE_INTERVENTION_ADDRESS = gql`
  mutation createInterventionAddress(
    $where: FolderWhereInput
    $data: InputInterventionAddressData
  ) {
    createInterventionAddress(where: $where, data: $data) {
      civilityCode
      name
      firstname
      address1
      address2
      postCode
      town
      countryCode
      cellPhone
      phone
      forceData
      updateAccount
      email
      fullname
      civilityDesc
      countryDesc
      languageDesc
      geolocalized
      updatable
    }
  }
`;
